import { render, staticRenderFns } from "./redbookNote.vue?vue&type=template&id=1e63f246"
import script from "./redbookNote.vue?vue&type=script&lang=js"
export * from "./redbookNote.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports